<template>
  <el-dialog
    :title="$t('addMenuCatalog.add')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="closeDialog"
  >
    <el-form
      ref="form"
      :model="addMenuCatalogInfo"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item
        :label="$t('addMenuCatalog.name')"
        prop="name"
      >
        <el-input
          v-model="addMenuCatalogInfo.name"
          :placeholder="$t('addMenuCatalog.requiredName')"
        />
      </el-form-item>
      <el-form-item
        :label="$t('addMenuCatalog.icon')"
        prop="icon"
      >
        <el-input
          v-model="addMenuCatalogInfo.icon"
          :placeholder="$t('addMenuCatalog.requiredIcon')"
        />
      </el-form-item>
      <el-form-item
        :label="$t('addMenuCatalog.sequence')"
        prop="seq"
      >
        <el-input
          v-model="addMenuCatalogInfo.seq"
          :placeholder="$t('addMenuCatalog.requiredSequence')"
        />
      </el-form-item>
      <el-form-item
        :label="$t('addMenuCatalog.storeType')"
        prop="storeType"
      >
        <el-select
          v-model="addMenuCatalogInfo.storeType"
          :placeholder="$t('addMenuCatalog.requiredStoreType')"
          style="width:100%"
        >
          <el-option
            :label="$t('addMenuCatalog.operationTeam')"
            value="800900000001"
          />
          <el-option
            :label="$t('addMenuCatalog.merchant')"
            value="800900000005"
          />
          <el-option
            :label="$t('addMenuCatalog.developmentTeam')"
            value="800900000000"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('addMenuCatalog.page')"
        prop="url"
      >
        <el-input
          v-model="addMenuCatalogInfo.url"
          :placeholder="$t('addMenuCatalog.requiredPage')"
        />
      </el-form-item>
      <el-form-item
        :label="$t('addMenuCatalog.isShow')"
        prop="isShow"
      >
        <el-select
          v-model="addMenuCatalogInfo.isShow"
          :placeholder="$t('addMenuCatalog.requiredIsShow')"
          style="width:100%"
        >
          <el-option
            :label="$t('addMenuCatalog.yes')"
            value="Y"
          />
          <el-option
            :label="$t('addMenuCatalog.no')"
            value="N"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button
        type="primary"
        @click="saveMenuCatalogInfo"
      >
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveMenuCatalog } from '@/api/dev/menuCatalogApi'

export default {
  name: 'AddMenuCatalog',
  data() {
    return {
      dialogVisible: false,
      addMenuCatalogInfo: {
        name: '',
        icon: '',
        seq: '',
        storeType: '',
        url: '',
        isShow: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('addMenuCatalog.nameRequired'), trigger: 'blur' },
          { max: 10, message: this.$t('addMenuCatalog.nameMaxLength'), trigger: 'blur' }
        ],
        icon: [
          { required: true, message: this.$t('addMenuCatalog.iconRequired'), trigger: 'blur' },
          { max: 20, message: this.$t('addMenuCatalog.iconMaxLength'), trigger: 'blur' }
        ],
        seq: [
          { required: true, message: this.$t('addMenuCatalog.seqRequired'), trigger: 'blur' },
          { max: 11, message: this.$t('addMenuCatalog.seqMaxLength'), trigger: 'blur' }
        ],
        storeType: [
          { required: true, message: this.$t('addMenuCatalog.storeTypeRequired'), trigger: 'change' }
        ],
        url: [
          { required: true, message: this.$t('addMenuCatalog.urlRequired'), trigger: 'blur' },
          { max: 256, message: this.$t('addMenuCatalog.urlMaxLength'), trigger: 'blur' }
        ],
        isShow: [
          { required: true, message: this.$t('addMenuCatalog.isShowRequired'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.addMenuCatalogInfo = {
        name: '',
        icon: '',
        seq: '',
        storeType: '',
        url: '',
        isShow: ''
      }
    },
    async saveMenuCatalogInfo() {
      try {
        await this.$refs.form.validate()
        const res = await saveMenuCatalog(this.addMenuCatalogInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('addMenuCatalog.addSuccess'))
          this.closeDialog()
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>